(() => {
  const runtime = window.BogerSections;
  if (!runtime) return;
  runtime.register('care-size-reference', '[data-care-workspace]', (workspace, { signal }) => {
    const unitButtons = [...workspace.querySelectorAll('[data-care-unit]')];
    const sizeInputs = [...workspace.querySelectorAll("input[name='care-size']")];
    const sizeRows = [...workspace.querySelectorAll('[data-size-row]')];
    const status = workspace.querySelector('[data-size-status]');
    const clear = workspace.querySelector('[data-clear-size]');
    const unitLong = workspace.querySelector('[data-care-unit-long]');
    if (!unitButtons.length || !sizeInputs.length || !status || !clear) return;
    let unit = 'cm';
    const format = values => unit === 'cm' ? `${values[0]}-${values[1]} cm` : `${(values[0] / 2.54).toFixed(1)}-${(values[1] / 2.54).toFixed(1)} in`;
    const setUnit = next => {
      if (!['cm', 'in'].includes(next)) return;
      unit = next;
      unitButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.careUnit === unit)));
      if (unitLong) unitLong.textContent = unit === 'cm' ? 'centimetres' : 'inches';
      workspace.querySelectorAll('[data-range]').forEach(cell => { cell.textContent = format(cell.dataset.range.split(',').map(Number)); });
    };
    const setSize = next => {
      sizeInputs.forEach(input => { input.checked = input.value === next; });
      sizeRows.forEach(row => row.classList.toggle('is-selected', row.dataset.sizeRow === next));
      clear.disabled = !next;
      status.textContent = next ? `${next} is highlighted for comparison only. Fit is not confirmed.` : 'No size selected. Choose S, M or L only if you want to highlight one supplier reference row.';
    };
    unitButtons.forEach(button => button.addEventListener('click', () => setUnit(button.dataset.careUnit), { signal }));
    sizeInputs.forEach(input => input.addEventListener('change', () => setSize(input.value), { signal }));
    clear.addEventListener('click', () => { setSize(''); sizeInputs[0].focus(); }, { signal });
    setUnit('cm');
    setSize('');
  });
})();
